






import { BaseSelect, selectName } from '#components/baseSelect';

import { NAME } from '../constants';

type Data = {
	REKLTXT_ID: number,
	REKL_TEXT1: string,
	REKL_TEXT2: string,
};

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		labelKey: { type: String, default: 'tcmenupReklText' },
		showLabel: { type: Boolean, default: true },
		inputDisabled: { type: Boolean, default: undefined },
	},
	data() {
		return {
			storeObject: NAME,
			emptyObject: {
				value: null,
				text: null,
			},
		};
	},
	computed: {
		inputDisabledCmp() {
			return this.isDisabled || this.inputDisabled;
		},
	},
	methods: {
		dbToBaseMapper(data: Data) {
			return {
				id: data.REKLTXT_ID,
				text1: data.REKL_TEXT1,
				text2: data.REKL_TEXT2,
			};
		},
	},
});
